"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TESLA_FREMONT_LEVEL = exports.MEASUREMENT_SYSTEM = exports.MAP_TYPE = void 0;
// Map code is old and both BE and FE expect snake case

/* eslint-disable camelcase */
var MAP_TYPE;
exports.MAP_TYPE = MAP_TYPE;

(function (MAP_TYPE) {
  MAP_TYPE["aerial"] = "Aerial";
  MAP_TYPE["aerialWithLabels"] = "AerialWithLabels";
  MAP_TYPE["topography"] = "Topography";
})(MAP_TYPE || (exports.MAP_TYPE = MAP_TYPE = {}));

var MEASUREMENT_SYSTEM;
exports.MEASUREMENT_SYSTEM = MEASUREMENT_SYSTEM;

(function (MEASUREMENT_SYSTEM) {
  MEASUREMENT_SYSTEM["imperial"] = "imperial";
  MEASUREMENT_SYSTEM["metric"] = "metric";
})(MEASUREMENT_SYSTEM || (exports.MEASUREMENT_SYSTEM = MEASUREMENT_SYSTEM = {}));

var TESLA_FREMONT_LEVEL;
exports.TESLA_FREMONT_LEVEL = TESLA_FREMONT_LEVEL;

(function (TESLA_FREMONT_LEVEL) {
  TESLA_FREMONT_LEVEL["fremontLevelOne"] = "FremontLevelOne";
  TESLA_FREMONT_LEVEL["fremontLevelTwo"] = "FremontLevelTwo";
  TESLA_FREMONT_LEVEL["none"] = "None";
})(TESLA_FREMONT_LEVEL || (exports.TESLA_FREMONT_LEVEL = TESLA_FREMONT_LEVEL = {}));